import { inferLicenseKind } from '../constants/parecerTemplates';

export function addDaysIso(iso, days) {
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return '';
  d.setDate(d.getDate() + Number(days || 0));
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function suggestLicenseValidade(aberturaIso, tipoNome, prazoDays) {
  const kind = inferLicenseKind(tipoNome);
  const map = prazoDays && typeof prazoDays === 'object' ? prazoDays : {};
  const raw = map[kind] ?? map.default ?? 365;
  const days = Number(raw);
  const safeDays = Number.isFinite(days) && days > 0 ? days : 365;
  return { kind, days: safeDays, validade: addDaysIso(aberturaIso, safeDays) };
}
